import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link, Redirect } from 'react-router-dom'
import { t, getCurrentLanguage } from 'translation'
import history from 'utils/appHistory'
import Helmet from 'react-helmet'

import AuthLoginForm from 'components/Auth/AuthLoginForm'
import AuthSetPasswordForm from 'components/Auth/AuthSetPasswordForm'
import AuthResetPasswordEmailForm from 'components/Auth/AuthResetPasswordEmailForm'
import AuthEnterPasswordCodeForm from 'components/Auth/AuthEnterPasswordCodeForm'
// import Steps from 'components/Steps/Steps';

import {
  forgotPasswordSubmitEmail,
  forgotPasswordSubmitCode,
  logIn,
  resetAuthError,
  setNewPassword,
} from 'store/actions'

import BgLoginImg from 'assets/woman.jpg'
import LogoLoginImg from 'assets/logo_tr.png'

class AuthPage extends Component {
  state = {
    scaleClassIsSet: false,
    resetPasswordForm: false,
    resetPasswordEmail: '',
    enterPasswordCodeForm: false,
  }

  submitFormHandler = async ({ email, password, code }) => {
    if (this.state.enterPasswordCodeForm) {
      console.log('email, password, code:', email, password, code)

      const success = await this.props.forgotPasswordSubmitCode({
        code,
        email: this.state.resetPasswordEmail,
        newPassword: password,
      })
      if (success) history.go(0)
    } else if (this.state.resetPasswordForm) {
      const success = await this.props.forgotPasswordSubmitEmail({ email })

      if (success) {
        this.setState({
          resetPasswordEmail: email,
          enterPasswordCodeForm: true,
          resetPasswordForm: false,
        })
      }
    } else if (this.props?.user?.challengeName === 'NEW_PASSWORD_REQUIRED')
      this.props.setNewPassword({ password })
    else this.props.logIn({ email, password })

    // TODO
    // if (typeof response === 'object' && response.type === 'AUTH_FAIL') {
    //   // Set error message if authentication request failed
    //   if (response.error.startsWith('Request failed'))
    //     this.setState({ apiResponseError: 'AUTHENTICATION_ERROR' })
    //   // If just connection error or other error
    //   else this.setState({ apiResponseError: 'CONNECTION_ERROR' })
  }

  componentDidMount() {
    document.documentElement.classList.add('no_scale_mod')
    this.setState({ scaleClassIsSet: true })
  }

  componentWillUnmount() {
    // document.documentElement.classList.remove('no_scale_mod')
  }

  render() {
    const isDoctor = this.props.isDoctor
    const showWelcomeVideo =
      this.props.attributes?.permissions?.features?.alwaysOnWelcomeVideo

    const redirectPath =
      showWelcomeVideo && !isDoctor
        ? `/welcome`
        : isDoctor
        ? `/welcome-doctor`
        : '/indication-select'

    const ENV = process.env.NODE_ENV

    const googleClientId =
      ENV === 'production'
        ? process.env.AUTH_GOOGLE_CLIENT_ID_PRODUCTION
        : ENV === 'dev-remote'
        ? process.env.AUTH_GOOGLE_CLIENT_ID_DEV_REMOTE
        : process.env.AUTH_GOOGLE_CLIENT_ID_DEVELOPMENT

    return (
      <>
        <Helmet>
          <meta name="google-signin-client_id" content={googleClientId} />
        </Helmet>
        {this.props.isAuthenticated && history.location.path !== redirectPath ? (
          <Redirect to={redirectPath} />
        ) : null}
        <section className="section login_mod">
          {this.state.scaleClassIsSet && (
            <>
              <div className="section_bg login_mod">
                <img
                  className="section_bg_img"
                  src={BgLoginImg}
                  alt="section background"
                />
              </div>
              <div className="section_in login_mod">
                <div className="logo login_mod">
                  <img className="logo_img" src={LogoLoginImg} alt="logo" />
                </div>
                <div className="tab_content_wrap auth_block">
                  {this.props?.user?.challengeName === 'NEW_PASSWORD_REQUIRED' ? (
                    <AuthSetPasswordForm
                      formState={this.state}
                      submitFormHandler={this.submitFormHandler}
                      apiResponseError={this.props.error || ''}
                      resetApiResponseError={() => this.props.resetAuthError()}
                    />
                  ) : this.state.enterPasswordCodeForm ? (
                    <AuthEnterPasswordCodeForm
                      submitFormHandler={this.submitFormHandler}
                      apiResponseError={this.props.error || ''}
                      resetApiResponseError={() => this.props.resetAuthError()}
                      goBackHandler={() =>
                        this.setState({
                          enterPasswordCodeForm: false,
                          resetPasswordForm: true,
                        })
                      }
                    />
                  ) : this.state.resetPasswordForm ? (
                    <AuthResetPasswordEmailForm
                      needButton={true}
                      submitFormHandler={this.submitFormHandler}
                      apiResponseError={this.props.error || ''}
                      alreadyHaveCodeHandler={(email) =>
                        this.setState({
                          enterPasswordCodeForm: true,
                          resetPasswordForm: false,
                          resetPasswordEmail: email,
                        })
                      }
                      resetApiResponseError={() => this.props.resetAuthError()}
                      goBackHandler={() =>
                        this.setState({
                          enterPasswordCodeForm: false,
                          resetPasswordForm: false,
                          resetPasswordEmail: '',
                        })
                      }
                    />
                  ) : (
                    <AuthLoginForm
                      formState={this.state}
                      submitFormHandler={this.submitFormHandler}
                      resetPasswordHandler={() =>
                        this.setState({ resetPasswordForm: true })
                      }
                      apiResponseError={this.props.error || ''}
                      resetApiResponseError={() => this.props.resetAuthError()}
                    />
                  )}
                </div>
              </div>
            </>
          )}
        </section>
      </>
    )
  }
}

const mapStateToProps = ({
  auth: { attributes, error, loading, isAuthenticated, isDoctor, user },
}) => ({
  attributes,
  loading,
  error,
  isAuthenticated,
  isDoctor,
  user,
})

const willMapDispatchToProps = {
  logIn,
  resetAuthError,
  setNewPassword,
  forgotPasswordSubmitEmail,
  forgotPasswordSubmitCode,
}

export default connect(mapStateToProps, willMapDispatchToProps)(AuthPage)
